import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { ContentService } from '@shared/services/content/content.service';
import * as fromRootStore from '@store/index';
import { filter, switchMap, withLatestFrom } from 'rxjs';

import { LoadContent, LoadContentSuccess } from '../../actions';

@Injectable()
export class ContentEffects {
  constructor(
    private actions$: Actions,
    private contentService: ContentService,
    private globalStore$: Store<fromRootStore.State>,
  ) {}

  loadContent$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LoadContent),
      withLatestFrom(this.globalStore$),
      filter(([, storeState]) => {
        return Boolean(!storeState.content.loaded);
      }),
      switchMap(() => {
        return this.contentService
          .getContent()
          .pipe(switchMap((content) => [LoadContentSuccess({ payload: content })]));
      }),
    ),
  );
}
